import { useEffect, useState } from "react";
import { Toggle } from "@narmi/design_system";
import { FILTER_CONFIG, FilterChipsType, FilterType } from "../filterConfig";
import styles from "../Filters.module.scss";
import ActionBar from "./ActionBar";
import FilterChip from "./FilterChip";

type BooleanFilterProps = FilterType & {
  filterName: FilterChipsType;
  label: string;
  toggleLabel: string;
};

const BooleanFilter = ({
  filters,
  isActive,
  handleSetActive,
  handleSetFilter,
  handleToggleFilter,
  filterName,
  label,
  toggleLabel,
}: BooleanFilterProps) => {
  const [isEnabled, setIsEnabled] = useState(false);
  const config = FILTER_CONFIG[filterName];

  if (config.type !== "boolean") {
    return null;
  }

  const { queryKey } = config;
  const count = filters[queryKey] ? 1 : undefined;

  useEffect(() => {
    setIsEnabled(filters[queryKey] === true);
  }, [filters, queryKey, isActive]);

  const handleToggleChip = () => {
    handleSetActive(isActive ? "" : filterName);
  };

  const handleApplyFilter = () => {
    handleSetFilter({
      ...filters,
      [queryKey]: isEnabled ? true : undefined,
    });
    handleToggleChip();
  };

  const handleRemoveFilter = () => {
    handleToggleFilter(filterName);
  };

  const renderDropdown = () => (
    <>
      <div className={styles.filterDropdownContent}>
        <Toggle
          isActive={isEnabled}
          onChange={(nextIsActive: boolean) => setIsEnabled(nextIsActive)}
          label={toggleLabel}
        />
      </div>
      <ActionBar
        handleApplyFilter={handleApplyFilter}
        handleRemoveFilter={handleRemoveFilter}
      />
    </>
  );

  return (
    <FilterChip
      dropdownContent={renderDropdown()}
      isActive={isActive}
      handleToggleChip={handleToggleChip}
      label={label}
      count={count}
    />
  );
};

export default BooleanFilter;
